$(function() {

  var dirRtlFlag = false;
  if ($("html").attr('dir') == 'rtl') {
    dirRtlFlag = true;
  }


  $('.box-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 100,
    rtl: dirRtlFlag,
    centerMode: false,
    slidesToShow: 7,
    slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1650,
        settings: {
        slidesToShow: 9,
        slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1350,
        settings: {
        slidesToShow: 7,
        slidesToScroll: 1
        }
      },
      {
        breakpoint: 1050,
        settings: {
        slidesToShow: 4,
        slidesToScroll: 1
        }
      },
      {
        breakpoint: 780,
        settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        }
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
      ] 
    });

    $('.articles-slider').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 2000,
      autoplay: true,
      autoplaySpeed: 100,
      rtl: dirRtlFlag,
      centerMode: false,
      slidesToShow: 4,
      slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 1650,
          settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          }
        },
        {
          breakpoint: 1350,
          settings: {
          slidesToShow: 3,
          slidesToScroll: 1
          }
        },
        {
          breakpoint: 1050,
          settings: {
          slidesToShow: 2,
          slidesToScroll: 1
          }
        },
        {
          breakpoint: 780,
          settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          }
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
        ] 
      });
});




$(document).ready(function() {
	$('.main-gallery2').lightGallery({
		thumbnail: true,
		animateThumb: false,
		showThumbByDefault: false,
		selector: '.gallery-item2'
	});


	function add() {
    $(items[i]).addClass('gallery-item2_long');
    $(items[i]).find('.gallery-item2__img').attr('src', $(items[i]).attr('data-src-long'));
    
	}

	var items = $('.main-gallery2').children();
	var long1 = 1;
	var long2 = 3;
	var long3 = 8;
	var step = 9;

	for (var i = 0; i < items.length; i++) {
		switch (i) {
			case long1:
				add();
				long1 += step;
				break;
			case long2:
				add();
				long2 += step;
				break;
			case long3:
				add();
				long3 += step;
				break;
		}
	}

  
})